import {
  AKA_TRAVEL_PRICE_STEP,
  AKA_TRAVEL_YOUR_PRODUCT_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel";

import { akaTravelCoverages } from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel/akaTravelConstants";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";

export function mapFromCommerceAkaTravel(data: {
  [key: string]: any;
}): FormStates {
  const { coverageGroup } = data;
  const isInsuranceFor = booleanToFormBoolean(
    akaTravelCoverages[coverageGroup].forInsuredOnly,
  );
  return {
    [AKA_TRAVEL_YOUR_PRODUCT_STEP.id]: {
      isInsuranceFor,
    },
    [AKA_TRAVEL_PRICE_STEP.id]: {
      coverage: coverageGroup,
    },
  };
}
